import { Exception } from 'src/app/core/logic/exception';

export class DiaryNotFoundException extends Exception<never> {
  constructor() {
    super('Journal non trouvé');
  }
}
